export var AudioSendRouting;
(function (AudioSendRouting) {
    AudioSendRouting[AudioSendRouting["Pre"] = 0] = "Pre";
    AudioSendRouting[AudioSendRouting["Post"] = 1] = "Post";
})(AudioSendRouting || (AudioSendRouting = {}));
